export * from "-!../../../node_modules/vue-style-loader/index.js!../../../node_modules/css-loader/index.js!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DashboardLibrarian.vue?vue&type=style&index=0&id=1acf0120&prod&scoped=true&lang=css&"


//////////////////
// WEBPACK FOOTER
// ./src/views/dashboard/DashboardLibrarian.vue?vue&type=style&index=0&id=1acf0120&prod&scoped=true&lang=css&
// module id = 967
// module chunks = 0